import { dateShortString, } from '~/utils/dateFormatingMethods';

export const shortDate = (value: Date | null) => {
	if (value instanceof Date) {
		return dateShortString(value);
	}
	return value;
};
